module.exports = __webpack_public_path__ + "img/kolor-07.63aea413.png";